if (!customElements.get('sc-inline-reviews')) {
  class SCInlineReviews extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.track = this.querySelector('[data-sc-review-track]');
      this.cards = Array.from(this.querySelectorAll('[data-sc-review-card]'));
      this.dialog = this.querySelector('[data-sc-review-dialog]');
      if (!this.track || !this.cards.length || !this.dialog) return;
      this.initialized = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.status = this.querySelector('[data-sc-review-status]');
      this.querySelector('[data-sc-review-prev]').addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-sc-review-next]').addEventListener('click', () => this.move(1), options);
      this.cards.forEach((card) => card.addEventListener('click', () => this.openReview(card), options));
      this.querySelector('[data-sc-review-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.track.addEventListener('keydown', (event) => {
        const actions = { ArrowLeft: -1, ArrowRight: 1, Home: 'first', End: 'last' };
        if (!(event.key in actions)) return;
        event.preventDefault();
        this.move(actions[event.key], true);
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.announce(this.currentIndex()));
      }, { ...options, passive: true });
      this.announce(0);
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.scrollFrame);
      if (this.dialog?.open) this.dialog.close();
      this.initialized = false;
    }
    slideOffsets() {
      const firstOffset = this.cards[0].closest('li').offsetLeft;
      return this.cards.map((card) => card.closest('li').offsetLeft - firstOffset);
    }
    currentIndex() {
      const offsets = this.slideOffsets();
      return offsets.reduce((closest, offset, index) => Math.abs(offset - this.track.scrollLeft) < Math.abs(offsets[closest] - this.track.scrollLeft) ? index : closest, 0);
    }
    announce(index) {
      if (!this.status || index === this.announcedIndex) return;
      this.announcedIndex = index;
      this.status.textContent = this.status.dataset.reviewStatusTemplate.replace('__current__', String(index + 1));
    }
    move(direction, focus = false) {
      const offsets = this.slideOffsets();
      const current = this.currentIndex();
      const next = direction === 'first' ? 0 : direction === 'last' ? this.cards.length - 1 : (current + direction + this.cards.length) % this.cards.length;
      const offset = offsets[next];
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollTo({ left: offset, behavior });
      if (focus) this.cards[next].focus({ preventScroll: true });
    }
    openReview(card) {
      const data = card.dataset;
      this.returnFocus = card;
      this.dialog.querySelector('[data-sc-review-dialog-name]').textContent = data.reviewName;
      this.dialog.querySelector('[data-sc-review-dialog-text]').textContent = `« ${data.reviewText} »`;
      const image = this.dialog.querySelector('[data-sc-review-dialog-photo]');
      image.src = data.reviewImage;
      image.alt = data.reviewImageAlt;
      this.dialog.querySelector('[data-sc-review-dialog-link]').href = data.reviewImage;
      const stars = this.dialog.querySelector('[data-sc-review-dialog-stars]');
      stars.setAttribute('aria-label', data.reviewRatingLabel);
      stars.querySelectorAll('span').forEach((star, index) => star.classList.toggle('is-empty', index >= Number(data.reviewRating)));
      if (!this.dialog.open) this.dialog.showModal();
    }
  }
  customElements.define('sc-inline-reviews', SCInlineReviews);
}
